import { OptionSelect } from "@/components/ui/option-select";
import { useAccountScope } from "@/context/AccountScopeContext";
import { ALL_ACCOUNTS } from "@/lib/accountScope";
import { accountTypeMeta } from "@/lib/accounts";
import { Stack } from "@phosphor-icons/react";

const ALL_ACCOUNTS_OPTION = {
  value: ALL_ACCOUNTS,
  label: "All accounts",
  icon: <Stack size={15} className="shrink-0 text-muted-foreground" />,
  testid: "account-scope-all",
};

function accountOption(account) {
  const Icon = accountTypeMeta(account.type).icon;
  return {
    value: account.id,
    label: account.name,
    icon: <Icon size={15} className="shrink-0 text-muted-foreground" />,
    testid: `account-scope-${account.id}`,
  };
}

/**
 * The global account filter. With a single account there is nothing to
 * choose between, so it stays out of the way until a second one exists.
 */
export default function AccountScopeSelect() {
  const { accounts, scope, setScope } = useAccountScope();
  if (accounts.length < 2) return null;

  return (
    <OptionSelect
      title="Account"
      options={[ALL_ACCOUNTS_OPTION, ...accounts.map(accountOption)]}
      value={scope}
      onValueChange={setScope}
      data-testid="account-scope-select"
      className="h-9 w-[150px] min-w-0 shrink bg-card border-border text-sm sm:w-[200px] touch:h-10"
    />
  );
}
